export default __webpack_public_path__ + "static/media/cafe_bolsa.d1bd9076.png";